import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgClass, NgFor, NgIf, NgStyle} from '@angular/common';
import {CdkDragDrop, moveItemInArray, transferArrayItem, DragDropModule} from '@angular/cdk/drag-drop';
import {
  CardQuestionnaireCategoryDto,
  CardQuestionnaireOptionDto,
  InteractionAnswerSaveDto,
  InteractionCardDto, InteractionsCardCategoryDto,
  ResultsDto,
} from '../../models/card.model';
import {CardResultsComponent} from '../card-results/card-results.component';
import {CardButtonComponent} from '../card-button/card-button.component';
import {ConferenceService} from '../../service/conference.service';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-card-drag-to-group',
  templateUrl: './card-drag-to-group.component.html',
  styleUrls: ['./card-drag-to-group.component.scss'],
  standalone: true,
  imports: [NgStyle, NgClass, NgIf, NgFor, DragDropModule, CardResultsComponent, CardButtonComponent, TranslateModule],
})

export class CardDragToGroupComponent implements OnInit {
  @Output() onSubmit = new EventEmitter<InteractionAnswerSaveDto>();

  @Input() set card(card: InteractionCardDto) {
    this._card = card;
    this.isSubmitted = (card.cardAnswer && card.cardAnswer.isCompleted);

    this.initData();
    this.switchViews();
  }

  @Input() set isResults(isResults: boolean) {
    this._isResults = isResults;
    this.switchViews();
  }

  isEnableSwitchViews: boolean = false;
  isSubmitted: boolean = false;

  _isResults: boolean | null = null;
  isShowingResults: boolean | null = null;

  _card: InteractionCardDto = {} as InteractionCardDto;
  options: CardQuestionnaireOptionDto[] = [];
  groups: CardQuestionnaireCategoryDto[] = [];
  groupsIds: string[] = [];

  results: ResultsDto | null = null;

  constructor(
    private conferenceService: ConferenceService,
  ) {
  }

  ngOnInit() {
  }

  initData() {
    const options = this._card.interactionsCardItems.map(item => this.extractInteractionAnswer(item));
    this.options = options.filter(o => !o.valueText);
    if (this._card.interactionsCardCategories) {
      this.groups = this._card.interactionsCardCategories.map(category => {
        return {
          ...category,
          options: options.filter(o => category.id === o.valueText)
        };
      });
    }

    this.groupsIds = this.groups.map(group => group.id).concat(['source']);
  }

  onDrop(event: CdkDragDrop<any[]>) {
    if (this.isSubmitted) {
      return;
    }

    if (event.previousContainer === event.container) {
      // Move within the same container
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      event.previousContainer.data[event.previousIndex].valueText = event.container.id == 'source' ? null : event.container.id;

      // Transfer item between containers
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  isPassed(options: CardQuestionnaireOptionDto[]) {
    return options.every(o => o.item.interactionCardCategoryId == o.valueText);
  }

  submit() {
    const options = this.groups.reduce((acc, group: any) => {
      return acc.concat(group.options);
    }, []);

    this.isSubmitted = true;
    const payload = {
      interactionCardId: this._card.id,
      score: this._card.score,
      isCompleted: true,
      isPassed: this._card.isNoCorrect || this.isPassed(options),
      groupExtId: 0,
      text: '',
      InteractionAnswerItems: options.map((o: any) => ({
        interactionsCardItemId: o.item.id,
        value: 0,
        valueText: o.valueText,
        score: o.item.score,
      })),
    } as InteractionAnswerSaveDto;

    this.onSubmit.emit(payload);
  }

  private extractInteractionAnswer(item: any) {
    return {
      isSelected: item.cardItemAnswer && item.cardItemAnswer.value > 0 ? true : false,
      value: item.cardItemAnswer && item.cardItemAnswer.value > 0 ? item.cardItemAnswer.value : 0,
      valueText: item.cardItemAnswer ? item.cardItemAnswer.valueText : null,
      item
    };
  }

  switchViews() {
    if (this._isResults === null) {
      return;
    }

    if (this._isResults) {
      this.showResults();
    } else {
      this.hideResults();
    }
  }

  showResults() {
    this.conferenceService.getStatisticsExt(this._card.id, 0)
      .then((statistics) => {
        console.log('statisticsExt', statistics);
      });

    this.conferenceService.getStatistics(this._card.id, 0)
      .then((statistics) => {
        console.log('statistics', statistics);

        const percentPassed = statistics.interactionCardAnswersCount > 0 ? statistics.interactionCardAnswersPassed / statistics.interactionCardAnswersCount : 0;
        const percentFailed = 1 - percentPassed;

        this.results = {
          items: [
            {
              value: percentPassed,
              label: (percentPassed * 100).toFixed(0) + '%',
              title: 'Correct answers',
              status: 'positive',
            },
            {
              value: percentFailed,
              label: (percentFailed * 100).toFixed(0) + '%',
              title: 'Incorrect answers',
              status: 'negative',
            },
          ]
        };

        this.isShowingResults = true;

      });
  }

  hideResults() {
    this.isShowingResults = false;
  }
}
